<div class="absolute inset-0 flex flex-col min-w-0 overflow-hidden">
  <div
    class="flex sm:flex-row flex-0 sm:items-center sm:justify-between p-6 pb-22 sm:pt-12 sm:pb-28 sm:px-10 bg-default dark:bg-transparent"
  >
    <div class="flex-1 min-w-0">
      <div>
        <div class="flex">
          <a
            class="inline-flex items-center -ml-1.5 text-secondary font-medium"
            [routerLink]="'/program-list'"
          >
            <mat-icon
              class="icon-size-5 text-secondary"
              [svgIcon]="'heroicons_solid:chevron-left'"
            ></mat-icon>
            <span class="ml-1">Back</span>
          </a>
        </div>
      </div>
      <div class="mt-2">
        <h2
          class="text-3xl md:text-4xl font-extrabold tracking-tight leading-7 sm:leading-10 truncate"
        >
          Program Details
        </h2>
      </div>
    </div>
    <div class="flex shrink-0 items-center sm:ml-4"></div>
  </div>
  <div
    class="flex-auto -mt-16 p-6 sm:p-10 rounded-t-2xl shadow overflow-y-auto bg-card"
    cdkScrollable
  >
    <div *ngIf="programDetails">
      <div class="mb-4">
        Class Schedule for<strong> {{ programDetails?.Name }}</strong>
      </div>
    </div>
    <div *ngIf="classSchedules?.length > 0; else noSchedules">
      <table
        mat-table
        [dataSource]="classSchedules"
        class="mat-elevation-z8"
        style="width: 100%"
      >
        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef>Name</th>
          <td mat-cell *matCellDef="let schedule; let i = index">
            <div *ngIf="!editingRow || editingRow.index !== i; else editName">
              {{ schedule.Name }}
            </div>
            <ng-template #editName>
              <mat-form-field appearance="fill" class="w-full">
                <input matInput [(ngModel)]="editingRow.data.Name" required />
              </mat-form-field>
            </ng-template>
          </td>
        </ng-container>

        <ng-container matColumnDef="spaces">
          <th mat-header-cell *matHeaderCellDef>Occupied Spaces</th>
          <td mat-cell *matCellDef="let schedule">
            <ng-container
              *ngIf="
                schedule.Booked_Count__c === schedule.Available_Spaces__c;
                else showFraction
              "
            >
              <span style="color: rgb(248, 119, 119); font-weight: bold"
                >Fully Booked</span
              >
            </ng-container>
            <ng-template #showFraction>
              {{
                schedule.Booked_Count__c + "/" + schedule.Available_Spaces__c
              }}
            </ng-template>
          </td>
        </ng-container>

        <ng-container matColumnDef="fee">
          <th mat-header-cell *matHeaderCellDef>Fee</th>
          <td mat-cell *matCellDef="let schedule; let i = index">
            <div>
              {{ schedule.Program_Fee__c | currency : "CAD" }}
            </div>
          </td>
        </ng-container>

        <ng-container matColumnDef="date">
          <th mat-header-cell *matHeaderCellDef>Date</th>
          <td mat-cell *matCellDef="let schedule">{{ schedule.Date__c }}</td>
        </ng-container>

        <ng-container matColumnDef="day">
          <th mat-header-cell *matHeaderCellDef>Day</th>
          <td mat-cell *matCellDef="let schedule">
            {{ schedule.Program_day__c }}
          </td>
        </ng-container>

        <ng-container matColumnDef="startTime">
          <th mat-header-cell *matHeaderCellDef>Start Time</th>
          <td mat-cell *matCellDef="let schedule">
            {{ schedule.formattedStartTime }}
          </td>
        </ng-container>

        <ng-container matColumnDef="endTime">
          <th mat-header-cell *matHeaderCellDef>End Time</th>
          <td mat-cell *matCellDef="let schedule">
            {{ schedule.formattedEndTime }}
          </td>
        </ng-container>

        <ng-container matColumnDef="actions" *ngIf="canEdit()">
          <th mat-header-cell *matHeaderCellDef>Actions</th>
          <td mat-cell *matCellDef="let schedule; let i = index">
            <div *ngIf="!editingRow || editingRow.index !== i; else saveCancel">
              <button mat-icon-button (click)="startEditing(i, schedule)">
                <mat-icon>edit</mat-icon>
              </button>
            </div>
            <ng-template #saveCancel>
              <button mat-icon-button color="accent" (click)="saveChanges()">
                <mat-icon>save</mat-icon>
              </button>
              <button mat-icon-button color="warn" (click)="cancelEditing()">
                <mat-icon>cancel</mat-icon>
              </button>
            </ng-template>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      </table>
    </div>
    <ng-template #noSchedules>
      <p>No class schedules available for this program.</p>
    </ng-template>
  </div>
</div>
